import Dispatch from "./client";

const urls = {
  organizations: {
    url: "/organization/",
    method: "get",
  },
  newOrganization: {
    url: "/organization",
    method: "post",
  },
  getUserOrgInfo: {
    url: "/organization/getUserInfo",
    method: "post"
  },
  orgDetail: {
    url: "/organization/getOrgDetail",
    method: "post"
  },
  inviteUserToOrg: {
    url: "/organization/invitation/invite",
    method: "post"
  },
  deleteOrg: {
    url: "/organization/deleteOrg",
    method: "post"
  },
  addDevice: {
    url: "/organization/addDevice",
    method: "post"
  },
  deleteDevice: {
    url: "/organization/deleteDevice",
    method: "post"
  },
  adminRequestCreateAccount: {
    url: "/organization/create/request",
    method: "post"
  },
  joinOrganization: {
    url: '/organization/invitation/join',
    method: 'post'
  },
  deleteUser: {
    url: '/organization/user/delete',
    method: 'post'
  },
  cancelInvitation: {
    url: '/organization/invitation/cancel',
    method: 'post'
  },
  updateOrganization: (id, method) => {
    return {
      url: `/organization/${id}`,
      method: method,
    };
  },

};

function api () {
  return {
    organizationAdminRequestCreateAccount : (data) =>
      Dispatch(urls.adminRequestCreateAccount , data.params , data.payload, data.options),
    deleteDevice : (data) =>
      Dispatch(urls.deleteDevice , data.params , data.payload, data.options),
    addDevice : (data) => 
      Dispatch(urls.addDevice , data.params , data.payload, data.options),
    getSpeceficOrgDetail : (data) =>
      Dispatch(urls.orgDetail , data.params , data.payload, data.options),
    inviteUserToOrg : (data) =>
      Dispatch(urls.inviteUserToOrg , data.params , data.payload, data.options),
    getUserOrgInfo : (data) =>
      Dispatch(urls.getUserOrgInfo, data.params, data.payload, data.options),
    getOrganizations: (data) =>
      Dispatch(urls.organizations, data.params, data.payload, data.options),
    deleteOrg: (data) =>
      Dispatch(urls.deleteOrg, data.params, data.payload, data.options),
    createOrganization: (data) =>
      Dispatch(urls.newOrganization, data.params, data.payload, data.options),
    deleteOrganization: (data) =>
      Dispatch(
        urls.updateOrganization(data.params.id, "delete"),
        {},
        data.payload,
				data.options
      ),
    editOrganization: (data) =>
      Dispatch(
        urls.updateOrganization(data.params.id, "put"),
        {},
        data.payload,
				data.options
      ),
		joinOrganization: data => Dispatch(urls.joinOrganization, data.params, data.payload, data.options),
		deleteUser: data => Dispatch(urls.deleteUser, data.params, data.payload, data.options),
		cancelInvitation: data => Dispatch(urls.cancelInvitation, data.params, data.payload, data.options)
  };
}
export default api();
